
import React from 'react';

export default function AuthPath() {

    ensureConnection();

    function ensureConnection() {

        window.location = "/api/v1/connectToQuickbooks";
    }

    return (
        <React.Fragment>
            Connecting to quickbooks.
        </React.Fragment>
    );
}